import { render, staticRenderFns } from "./twice-alarm-list.vue?vue&type=template&id=2f72e2de&scoped=true"
import script from "./twice-alarm-list.vue?vue&type=script&lang=js"
export * from "./twice-alarm-list.vue?vue&type=script&lang=js"
import style0 from "./twice-alarm-list.vue?vue&type=style&index=0&id=2f72e2de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f72e2de",
  null
  
)

export default component.exports